import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./index.less";
import Table from "./Table";

const QuoteStatuses = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(true);
  const [canDelete, setCanDelete] = useState(false);

  // useEffect(() => {
  //   if (user?.permissions?.quote_statuses?.add_edit) {
  //     setCanUpdate(true);
  //   }
  //   if (user?.permissions?.quote_statuses?.delete) {
  //     setCanDelete(true);
  //   }
  // }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Statuses Manager</span>
      <Table canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default QuoteStatuses;
